import * as Sentry from "@sentry/react";
import React from "react";
// import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './Navigation/Course/Content/Labs/Instructor/LabContainer/QuestionTAStyles/styles.css'

// import { createBrowserHistory } from "history";
import { Provider } from "react-redux";

// import { PersistGate } from "redux-persist/integration/react";
import { store } from "./Store";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import Navigation from "./Navigation";
import PageTracker from "analytics/components/PageTracker";
import "./index.scss";
import { createRoot } from "react-dom/client";
import ErrorBoundary from "ErrorBoundary";
import { ErrorReportProvider } from "Components/Common/ErrorReport";
// import log from "loglevel";
// log.setDefaultLevel("debug");
import log from 'loglevel';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { installGlobalErrorHandlers } from 'services/telemetry';
import MaintenanceGate from "Components/Common/MaintenanceGate";

// Before renderApp(), so an error while booting is still reported.
installGlobalErrorHandlers();

Sentry.init({
  dsn: "https://33cb59b81a724fa8bad85848a4ee2850@glitchtip.teson.xyz/7",
  environment: "production",
  tracesSampleRate: 0.1,
});

const showLogsOnConsole = process.env.REACT_APP_SHOW_LOGS_ON_CONSOLE === 'true' || process.env.REACT_APP_SHOW_LOGS_ON_CONSOLE === true || true;

if (showLogsOnConsole) {
  log.log({showLogsOnConsole, REACT_APP_SHOW_LOGS_ON_CONSOLE: process.env.REACT_APP_SHOW_LOGS_ON_CONSOLE})
  log.setLevel('debug');
  log.log("Displaying logs ...");
} else {
  log.setLevel('silent');
  log.log({showLogsOnConsole, REACT_APP_SHOW_LOGS_ON_CONSOLE: process.env.REACT_APP_SHOW_LOGS_ON_CONSOLE})
}


function renderApp() {
  createRoot(document.getElementById("root")).render(
    <DndProvider backend={HTML5Backend}>
      {/* <App /> */}
      <ToastContainer stacked />
      <Provider store={store}>
        {/* <PersistGate loading={<div>loading....</div>} persistor={await persistor}> */}
        {/* <ConnectedRouter history={history} children={Router.routes} /> */}
        {/* <ConnectedRouter> */}
        <MaintenanceGate>
          <ErrorReportProvider>
            <ErrorBoundary>
              <BrowserRouter>
                <PageTracker />
                <Navigation />
              </BrowserRouter>
            </ErrorBoundary>
          </ErrorReportProvider>
        </MaintenanceGate>
        {/* </ConnectedRouter> */}
        {/* </PersistGate> */}
      </Provider>
    </DndProvider>
  );
}

renderApp();

// serviceWorkerRegistration.register();
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      registration.unregister().then(success => {
        console.log('Unregistered a service worker:', success);
      });
    }
  }).catch(err => {
    console.error('Error unregistering service workers:', err);
  });
}
